<template>
  <div class="payback">
    <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{span: 4}" :wrapper-col="{span: 20}" class="rform" :class='{"editbox":$route.params.id}'>
      <a-spin :spinning="loading">
        <div class="cardli">
          <div class="h2">基本信息</div>
          <div class="rboxes">
            <a-row>
              <a-col :span='4'>
                <a-form-model-item label="债务人" prop="name" :label-col="{span:24}" :wrapper-col="{span: 20}" style="margin:0;" :rules="{ required: true, message: '请输入要搜索的债务人姓名',trigger: 'blur'}">
                  <a-select show-search v-model="form.name" :disabled="canUse" style="width:90%;" placeholder="请选择债务人" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" @search="handleSearch" @change="getcauseList">
                    <a-select-option v-for="d in debtorList" :key="d.id">
                      {{ d.realname }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span='5'>
                <a-form-model-item label="债务人证件号码" style="margin:0;" :label-col="{span:24}" :wrapper-col="{span: 20}">
                  <input :value='chinaId' class="input" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span='3'>
                <a-form-model-item label="所属案件" :label-col="{span:24}" :wrapper-col="{span: 20}" style="margin:0;" prop='cause_id' :rules="{ required: true, message: '请选择案件',trigger: 'change'}">
                  <a-select style="width:90%;" placeholder="请选择" v-model='form.cause_id' @change="getStepLists" :disabled="caseIng==2">
                    <!-- noenforcement_loan(i) ||  -->
                    <a-select-option :key="i.id" v-for='(i,index) in caseList' v-if="i.invaild==0">
                      案件 {{i.sort}}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span='5'>
                <a-form-model-item label="当前进度" style="margin:0;" :label-col="{span:24}" :wrapper-col="{span: 20}">
                  <input class="input" :value='step' disabled></input>
                </a-form-model-item>
              </a-col>
              <a-col :span='5'>
                <a-form-model-item label="原告" style="margin:0;" :label-col="{span:24}" :wrapper-col="{span: 20}">
                  <input class="input" :value='nowCause.accuser.title' disabled />
                </a-form-model-item>
              </a-col>
              <a-button type="primary" icon='plus' class="subs" v-if='form.cause_id && caseIng==0' @click='addAddCause'>添加回款</a-button>
            </a-row>
          </div>
        </div>
        <div class="cardli" style="padding-bottom:0;" v-if="form.cause_id">
          <div class="h2">关联分期</div>
          <div class="tablelist" v-if="loanList.length>0">
            <table class="table">
              <thead>
                <td width='232'>每期编号</td>
                <td width='142'>当前期数</td>
                <td width='126'>还款金额</td>
                <td width='150'>还款日期</td>
                <td width='120'>还款构成</td>
                <td width='122'>还款状态</td>
                <td width='118'>已还金额</td>
                <td width='138'>还款进度</td>
              </thead>
              <tbody>
                <tr v-for='(i,index) in loanList' :key='index'>
                  <td>
                    <Normap :tit='i.no'></Normap>
                  </td>
                  <td>第{{index+1}}期</td>
                  <td>{{i.fee/100 | toNum}}</td>
                  <td>{{i.time}}</td>
                  <td>
                    <a-popover>
                      <template slot="content">
                        <div class="contbox">
                          <p v-for='(k,inde) in i.fee_list'>{{k.type_title}}:{{k.fee | showYuan}}</p>
                        </div>
                      </template>
                      <span> {{Allfree(i.fee_list)}}</span>
                    </a-popover>
                  </td>
                  <td>
                    <span class="status ing" v-if='i.status==1'>待还款</span>
                    <span class="status succ" v-if='i.status==2'>已还款</span>
                    <span class="status err" v-if='i.status==3'>已逾期</span>
                    <span class="status oky" v-if='i.status==4'>已申请执行</span>
                  </td>
                  <td>
                    {{i.payee/100 | toNum}}
                  </td>
                  <td>
                    {{(i.payee/i.fee*100).toFixed(2)}}%
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
          <a-empty v-else style="padding:20px 0 40px;" description="暂无关联分期" />
        </div>
        <div class="cardli">
          <div class="h2">还款构成</div>
          <div class="forms">
            <div class="chbox">
              <a href="javascript:void(0);" v-for='(i,index) in usedCase' :key='index' :class='{"cur":index==useIndex}' @click='seeCause(index)'>案件 {{i.lite.sort}}</a>
            </div>
            <div class="boxmain" v-if='caseIng>=1'>
              <div class="celox">
                <div class="col">
                  <label>是否回款到分期：</label>
                  <a-radio-group button-style="solid" v-model="form.is_payee_for_loan">
                    <a-radio-button :value="1">
                      是
                    </a-radio-button>
                    <a-radio-button :value="0">
                      不是
                    </a-radio-button>
                  </a-radio-group>
                </div>
              </div>
              <div class="celox">
                <div class="col">
                  <label>还款金额：</label>
                  <span>{{allmoney.toFixed(2)}}</span>
                </div>
                <div class="col">
                  <label>还款日期：</label>
                  <a-date-picker v-model="form.time" placeholder="请选择" style="width: 150px;" valueFormat="YYYY-MM-DD" format='YYYY-MM-DD' :disabled='usedCase[useIndex].over==2' />
                </div>
              </div>
              <div class="countjs">
                <div class="cell">
                  <div class="cols">
                    <label>
                      本金
                    </label>
                    <input type="text" placeholder="请输入" v-model='form.list[0].fee' :disabled='usedCase[useIndex].over==2' />
                  </div>
                  <div class="cols">
                    <label>诉讼费</label>
                    <input type="text" placeholder="请输入" v-model='form.list[1].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                  <div class="cols">
                    <label>公告费</label>
                    <input type="text" placeholder="请输入" v-model='form.list[2].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                  <div class="cols">
                    <label>律师费</label>
                    <input type="text" placeholder="请输入" v-model='form.list[3].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                  <div class="cols">
                    <label>其他</label>
                    <input type="text" placeholder="请输入" v-model='form.list[4].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                </div>
                <div class="cell">
                  <div class="cols">
                    <label>利息</label>
                    <input type="text" placeholder="请输入" v-model='form.list[5].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                  <div class="cols">
                    <label>保全费</label>
                    <input type="text" placeholder="请输入" v-model='form.list[6].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                  <div class="cols">
                    <label>上诉费</label>
                    <input type="text" placeholder="请输入" v-model='form.list[7].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                  <div class="cols">
                    <label>差旅费</label>
                    <input type="text" placeholder="请输入" v-model='form.list[8].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                  <div class="cols">
                    <label>结清款</label>
                    <input type="text" placeholder="请输入" v-model='form.list[9].fee' :disabled='usedCase[useIndex].over==2'>
                  </div>
                </div>
                <div class="txtbox">
                  <label>备注</label>
                  <div class="textarea">
                    <textarea v-model='form.comment' maxlength="500" :disabled='usedCase[useIndex].over==2'></textarea>
                    <div class="bot">{{form.comment.length}}/500</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" class="elbtns" v-if='caseIng==1'>
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a href='javascript:void(0);' class="oky">
                提交
              </a>
            </a-popconfirm>
            <a-popconfirm title="确认取消此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="cancel">
              <a href='javascript:void(0);' class="cancel">取消</a>
            </a-popconfirm>
          </a-form-model-item>
        </div>

      </a-spin>
    </a-form-model>
  </div>
</template>
<script>
import { causeStep, debtorLists } from '@/server/api'
import { addCollection } from '@/server/collection'
import { loanDetails, getLoanList } from '@/server/loan'
const formKey = {
  name: '',
  cause_id: '',
  fee: '',
  time: '',
  is_payee_for_loan: null,
  comment: '',
  list: [
    {
      type: 8, fee: ''
    },
    {
      type: 1,
      fee: ''
    },
    {
      type: 2,
      fee: ''
    },
    {
      type: 4,
      fee: ''
    },
    {
      type: 7,
      fee: ''
    },
    {
      type: 9,
      fee: ''
    },
    {
      type: 3,
      fee: ''
    },
    {
      type: 10,
      fee: ''
    },
    {
      type: 5,
      fee: ''
    },
    {
      type: 11,
      fee: ''
    }
  ]
}
export default {
  data() {
    return {
      loanList: [],
      loading: false,
      rules: {},
      debtorList: [],    //债务人列表
      caseList: [],    //案件列表
      useIndex: 0,    //当前分期 索引
      usedCase: [
        {
          over: 0,   //0 初始 1正在修改 2已提交
          lite: {},   //对应案件信息
          form: {}   //对应案件存储信息
        }
      ],
      Case: {},    //当前案件
      nowCause: {
        accuser: {}
      },
      step: '',   //最新进度
      form: JSON.parse(JSON.stringify(formKey))
    }
  },
  created() {
    if (this.$route.query.id) {
      this.init()
    }
  },
  computed: {
    allmoney() {
      let arr = this.form.list.filter(ele => { return ele.fee > 0 }).map(ele => { return ele.fee * 1 })
      if (arr.length > 0) {
        return arr.reduce((prev, next) => {
          return prev + next
        })
      } else {
        return 0
      }
    },
    canUse() { //判读是否已添加过分期记录
      return this.usedCase.filter(ele => {
        return ele.over == 2
      }).length > 0
    },
    caseIng() {
      return this.usedCase[this.useIndex].over
    },
    chinaId() {
      if (this.debtorList.length > 0 && this.form.name) {
        const list = this.debtorList.filter(ele => { return ele.id === this.form.name })
        if (list.length > 0) {
          return list[0].chinaid
        }
      }
    }
  },
  methods: {
    getLoad(id) {
      getLoanList({ cause_id: id }).then(e => {
        this.loanList = e ? e.period : []
      })
    },
    hasCause(e) {     //静态新增的案件记录 过滤
      return this.usedCase.filter(ele => { return ele.over == 2 && ele.lite.id == e.id }).length > 0
    },
    seeCause(index) {   //待保留
      const usedCase = JSON.parse(JSON.stringify(this.usedCase))
      const nowOver = usedCase[this.useIndex]       //当前 焦点节点 index是当前点击
      if (usedCase.length <= 1) return false;
      if (usedCase[index].over == 0) {
        this.form.cause_id = null
        this.useIndex = index;
        return false;
      }
      if (nowOver.over == 1 && usedCase[index].over == 2) {        //保存数据
        usedCase[this.useIndex].form = this.form
        this.usedCase = usedCase
      }
      this.form = usedCase[index].form;
      this.useIndex = index;
    },
    async init() {  //初始化
      loanDetails({ debtor_id: this.$route.query.id }).then(res => {
        debtorLists({ chinaid: res.info.chinaid }).then(e => {
          this.debtorList = e.list
          this.getcauseList(res.info.id)
        })
        this.form.name = res.info.id
        this.loading = false;
      })
    },
    addAddCause() {  //新增回款
      let index = this.useIndex
      this.usedCase[index].over = 1;
      this.usedCase[index].lite = this.nowCause

    },
    async getcauseList(id) {        //获取案件
      this.caseList = []
      this.form.cause_id = null
      this.form.step = 0;
      this.step = null
      if (this.debtorList.length > 0) {
        let Arr = this.debtorList.filter(ele => {
          return ele.id == id
        })
        this.caseList = Arr.length > 0 ? Arr[0].cause : []
        this.Case = Arr.length > 0 ? Arr[0] : {}
        this.usedCase[this.useIndex].over = 0
      }
    },
    async getStepLists(cause_id) {      //获取进度
      let nowCase = this.caseList.find(ele => {
        return ele.id == cause_id
      })
      this.nowCause = nowCase
      this.getLoad(cause_id)
      causeStep({ cause_id: cause_id }).then(e => {
        // this.steplist = e.list.length>0?e.list[e.list.length-1]:""
        const step = e.list.length > 0 ? e.list[e.list.length - 1] : "暂无进度"
        this.step = e.list.length > 0 ? step.title : step;
        this.form.step = e.list.length > 0 ? step.step : 0
        this.usedCase[this.useIndex].over = 0
      })
    },
    async handleSearch(name) {
      if (name) {
        debtorLists({ realname: name ,limit:200}).then(e => {
          this.debtorList = e.list
        })
      } else {
        this.debtorList = []
      }
    },
    Allfree(Arr) {
      let i = 0;
      let newNum = Arr.map(e => {
        i += e.fee * 1 / 100
      })
      return i.toFixed(2)
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.form))
          let arr = []
          if (obj.is_payee_for_loan === null) {
            this.$message.error("请选择是否回款到分期")
            return false;
          }
          if (!obj.time) {
            this.$message.error("请选择还款日期")
            return false;
          }
          // if (obj.list[0].fee == 0) {
          //   this.$message.error("本金不能为空")
          //   return false;
          // }
          obj.list.forEach((ele) => {
            if (ele.fee) {
              ele.fee = (ele.fee * 100).toFixed(0)
              arr.push(ele)
            }
          })
          obj.list = arr
          if (arr.length == 0) {
            this.$message.error("还款构成金额相加必须等于还款金额")
            return false;
          }
          const allPrice = arr.map(ele => { return ele.fee * 1 }).reduce((s, a) => {
            return s + a
          })
          obj.fee = allPrice
          obj.list = obj.list.filter(ele => {
            return ele.fee > 0
          })
          delete obj.name
          addCollection(obj).then((res) => {
            this.$message.success({ content: '添加成功' });
            this.reset()
          })

        }
        else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      const usedCase = JSON.parse(JSON.stringify(this.usedCase))
      usedCase[this.useIndex].over = 0;
      let copayForm = JSON.parse(JSON.stringify(formKey))
      this.form.fee = ''
      this.form.cause_id = ''
      this.form.time = ''
      this.form.comment = ''
      this.form.list = copayForm.list
      this.usedCase = usedCase
    },
    reset() {
      let usedCase = JSON.parse(JSON.stringify(this.usedCase))
      usedCase[this.useIndex].over = 2;   //把当前设置为已完成
      let forms = JSON.parse(JSON.stringify(formKey));
      usedCase[this.useIndex].form = JSON.parse(JSON.stringify(this.form))
      usedCase.push({
        over: 0,   //0 初始 1正在修改 2已提交
        lite: {},   //对应案件信息
        form: {}   //对应案件存储信息
      })
      forms.name = this.form.name
      this.form = forms
      this.usedCase = usedCase
      this.useIndex = this.useIndex + 1
    }
  },
}
</script>
<style lang="less">
.payback {
  .lflabel {
    margin-bottom: 10px;
    .ant-form-item-label {
      text-align: left;
      width: 100px;
    }
    .ant-btn {
      padding: 0 6px;
      width: 84px;
      height: 28px;
      margin-right: 10px;
      color: #a2a3a5;
      font-size: 14px;
      span {
        margin-left: 4px;
      }
    }
    .ant-btn:hover,
    .ant-btn:focus {
      color: #1e8bfe;
      background-color: #fff;
      border-color: #1e8bfe;
    }
  }
  .rform {
    .ul {
      .ant-form-item-label {
        width: 60px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.cardli {
  background: #fff;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h2 {
    font-size: 16px;
    font-weight: 500;
    color: #0e2949;
    line-height: 62px;
    padding: 0 20px;
    font-weight: bold;
    border-bottom: 1px solid #efefef;
  }
  .tablelist {
    padding: 20px;
  }
  .dul {
    padding-top: 20px;
    background: #f3f6fb;
    border-radius: 4px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    .ul {
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
    }
    .dli {
      padding-left: 30px;
      width: 25%;
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      height: 40px;
      overflow: hidden;
      .ant-form-item {
        margin: 0;
      }
      .btns {
        margin-left: 20px;
        color: #f00;
        cursor: pointer;
      }
    }
  }
  .mr20 {
    margin-right: 20px;
  }
  .rboxes {
    padding: 18px 20px 0;
    label {
      display: block;
      font-size: 14px;
      font-weight: 500;
      color: #0e2949;
      line-height: 17px;
      margin-bottom: 6px;
    }
    .input {
      width: 100%;
      background-color: #fff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      padding: 0 11px;
      line-height: 32px;
      background: #f7f7f7;
    }
    .subs {
      margin-top: 32px;
      width: 117px;
      height: 34px;
      background: #1d8bfe;
      border-radius: 4px;
    }
  }
  .forms {
    padding: 0 20px;
    .chbox {
      margin-bottom: 14px;
      border-bottom: 1px solid #efefef;
      line-height: 50px;
      a {
        color: #333;
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        transition-duration: 500ms;
      }
      a:hover,
      .cur {
        color: #1d8bfe;
      }
    }

    .clearbox {
      /deep/ .ant-form-item {
        margin-bottom: 10px;
      }
    }
    .celox {
      display: flex;
      height: 32px;
      align-items: center;
      margin-bottom: 26px;
      .col {
        display: flex;
        min-width: 180px;
        font-size: 14px;
        color: #0e2949;
        line-height: 32px;
        span {
          font-size: 14px;
        }
      }
    }
    .countjs {
      .cell {
        display: flex;
        margin-bottom: 20px;
        .cols {
          display: flex;
          flex-direction: column;
          margin-right: 15px;
          label {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 5px;
          }
          input {
            width: 100px;
            height: 40px;
            background: #f3f6fb;
            border-radius: 4px;
            border: 0 none;
            text-align: center;
            font-size: 14px;
            font-weight: normal;
            color: #333;
          }
        }
      }
    }
  }
  .txtbox {
    margin-top: 20px;
    label {
      font-size: 14px;
      color: #0e2949;
    }
    .textarea {
      width: 572px;
      height: 132px;
      border-radius: 4px;
      border: 1px solid #dbdcde;
      padding: 10px;
      margin-top: 10px;
      textarea {
        width: 100%;
        height: 84px;
        border: 0 none;
      }
      .bot {
        text-align: right;
        font-size: 14px;
        color: rgba(162, 163, 165, 0.5);
        line-height: 20px;
      }
    }
  }
}
.elbtns {
  padding: 40px 0 0 20px;
  a {
    display: inline-block;
    width: 80px;
    line-height: 36px;
    background: #1d8bfe;
    border-radius: 4px;
    text-align: center;
    margin-right: 20px;
    color: #fff;
  }
  .cancel {
    background: #b2c9e1;
  }
}
</style>